// mst_referencemaster.referencecode - same values as OBJECTION_REFERENCE_CODE in
// mhcet_backend/config/constant.js. For WEBSITE the book title field must be an http(s) link and
// author name, edition and reference page count are optional; for any other reference they are mandatory.
export const REFERENCE_CODE = {
  BOOK: "BOOK",
  WEBSITE: "WEBSITE",
};

// Shown in the middle of the page when the courseid / course / examid params are missing or tampered.
export const INVALID_LINK_MESSAGE =
  "This link is invalid or has expired. Please open the Objection Tracker again from the portal.";

// sessionStorage key holding { courseid, course, examid } while the candidate is on Airpay.
// The Airpay return URL (objection-payment-status) carries no course / exam, so the status page
// reads them from here, as the application fee flow does with sessionStorage "courseid".
export const OBJECTION_PAYMENT_STORAGE_KEY = "objectionPayment";

// Same rules as the raise-objection API.
export const DOCUMENT_MAX_SIZE = 1 * 1024 * 1024;
export const DOCUMENT_TYPES = ["application/pdf", "image/jpeg", "image/jpg"];
export const DOCUMENT_EXTENSIONS = [".pdf", ".jpg", ".jpeg"];
